// define a mixin object
import { isEmpty, isNil } from 'lodash';

export default {

  computed: {
    settingsFullyLoaded: function () {
      if (this.$route.name === 'login') return true;
      if (!this.loaded) return false;
      if (isEmpty(this.$root.username)) return false;
      if (isNil(this.hotelSettings)) return false;
      if (isNil(this.hotelSettings.details)) return false;
      if (isNil(this.hotelSettings.details.primaryLanguage)) return false;
      if (isEmpty(this.enums)) return false;
      if (!this.$store.getters['enums/loaded']) return false;

      return true;
    },
  },

  created: function () {
    this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'hotel/HOTEL_SETTINGS') {
        this.hotelSettings = mutation.payload;
      }
    });
  },
};



// WEBPACK FOOTER //
// ./src/mixins/UpdateHotelSettingsMixin.js